import { api } from "@/api/client"
import { useMutation } from "@tanstack/react-query"
import { TokensResponse } from "../../../../backend/src/routes/schemes"

export const personificateUserRequest = async (token: string | undefined, userId: number) => {
    const { data } = await api({ token }).post<TokensResponse>(`/auth/personification`, { userId })
    return data
}

export const usePersonificateUserMutation = (token: string | undefined) => {
    return useMutation<TokensResponse, Error, number>({
        mutationFn: (userId: number) => personificateUserRequest(token, userId),
    })
}
